import styled from 'styled-components';

export const Title = styled.h1.attrs({
  className: 'text-2xl font-bold text-gray-900 mb-2',
})``;

export const Subtitle = styled.p.attrs({
  className: 'text-gray-600',
})``;

export const ErrorText = styled.div.attrs({
  className: 'text-red-600 text-sm mb-2',
})``;
